import Const from 'constants';

const defaultState = {
    data: {},
    getByPlayerIdAndMode(playerId, mode = Const.FLEX_MODE) {
        if (this.data.hasOwnProperty(mode) && this.data[mode].hasOwnProperty(playerId)) {
            return this.data[mode][playerId];
        }
        return Const.SYMPATHY_DEFAULT;
    },
    all() {
        return {...this.data};
    },
};

export default function (state = defaultState, action) {
    if (action.type === Const.SYMPATHY_SET_PLAYERS) {
        state = {...state};
        Object.keys(action.items).map((mode) => {
            state.data[mode] ??= {};

            Object.keys(action.items[mode]).map((playerId) => {
                if (action.items[mode][playerId]) {
                    state.data[mode][playerId] = action.items[mode][playerId];
                } else if (state.data[mode].hasOwnProperty(playerId)) {
                    delete state.data[mode][playerId];
                }
            });
        });
    } else if (inArray(action.type, [Const.RESET_ALL_SETTINGS, Const.FILTER_BY_SLATE])) {
        state = {...defaultState, data: {}};
    }

    return state;
}
